import { Component } from '@angular/core';

@Component({
    selector: 'tun-pause-track-v5',
    templateUrl: './pause-track-v5.component.html',
    styleUrl: './pause-track-v5.component.scss',
    standalone: false
})
export class PauseTrackV5Component {

}
